import React from "react";
import { SFUseStyled, SFStack, SFFatalError } from "@sf-core";

const { styled } = SFUseStyled();

const StyledPageWrapper = styled(SFStack)(({ theme }) => ({
  background: theme.palette.sf_bg_gradient.main,
  height: "100vh",
}));

const StyledErrorWrapper = styled(SFStack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  maxWidth: "778px",
  maxHeight: "370px",
  borderRadius: "8px",
  boxShadow: "0px 0px 40px 0px rgba(0, 0, 0, 0.06)",
}));

const FatalError = () => {
  return (
    <StyledPageWrapper
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <StyledErrorWrapper
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <SFFatalError />
      </StyledErrorWrapper>
    </StyledPageWrapper>
  );
};

export default FatalError;
